"use client";

import getOrderHandler from "@/interface/api/GetOrder";
import { useApi } from "./useApi";
import * as log from "@/actions/logger";

const useGetOrder = () => {
  const { request: requestGetOrder } = useApi(getOrderHandler.getOrder);

  const getOrder = async ({ applicationId }: { applicationId: string }) => {
    try {
      const response = await requestGetOrder({
        applicationId: applicationId,
      });
      return response?.data;
    } catch (e) {
      log.error({ err: e, module: "useGetOrder" }, "Error getting order");
      return null;
    }
  };

  return {
    getOrder,
  };
};

export default useGetOrder;
